import {createEntityMeta,SyncStatus} from '../offline/entity.js';

export const SESSION_OUTCOME_ENTITY_TYPE='smoking_session_outcome';

const DIMENSIONS=Object.freeze(['taste','smoke','juiciness','texture','appearance']);

function required(value,label,max=128){
  const text=String(value||'').trim();
  if(!text)throw new TypeError(label+' is required');
  if(text.length>max)throw new TypeError(label+' is too long');
  return text;
}
function rating(value,label,{requiredValue=false}={}){
  if(value==null||value===''){
    if(requiredValue)throw new TypeError(label+' is required');
    return null;
  }
  const n=Number(value);
  if(!Number.isInteger(n)||n<1||n>5)throw new TypeError(label+' must be an integer from 1 to 5');
  return n;
}
function text(value,max=4000){
  const v=String(value||'').trim();
  if(!v)return null;
  if(v.length>max)throw new TypeError('lessonsLearned is too long');
  return v;
}

export function createSessionOutcome({
  sessionId,userId,overallRating,taste=null,smoke=null,juiciness=null,texture=null,appearance=null,lessonsLearned=null
}={}){
  return Object.freeze({
    sessionId:required(sessionId,'sessionId'),
    userId:required(userId,'userId'),
    overallRating:rating(overallRating,'overallRating',{requiredValue:true}),
    taste:rating(taste,'taste'),smoke:rating(smoke,'smoke'),juiciness:rating(juiciness,'juiciness'),
    texture:rating(texture,'texture'),appearance:rating(appearance,'appearance'),
    lessonsLearned:text(lessonsLearned)
  });
}

export function sessionOutcomeToRow(value){
  const v=createSessionOutcome(value);
  return Object.freeze({
    session_id:v.sessionId,user_id:v.userId,overall_rating:v.overallRating,
    taste_rating:v.taste,smoke_rating:v.smoke,juiciness_rating:v.juiciness,
    texture_rating:v.texture,appearance_rating:v.appearance,lessons_learned:v.lessonsLearned
  });
}

export function createSessionOutcomeStore({repository,queue,userId,now=()=>new Date().toISOString()}={}){
  if(!repository?.get)throw new TypeError('repository is required');
  if(!queue?.enqueue)throw new TypeError('sync queue is required');
  const owner=required(userId,'userId');

  async function get(sessionId){
    const row=await repository.get(SESSION_OUTCOME_ENTITY_TYPE,required(sessionId,'sessionId'));
    if(!row||row.deletedAt)return null;
    if(row.userId!==owner)throw new Error('SESSION_OUTCOME_OWNER_MISMATCH');
    return Object.freeze(row);
  }
  async function save(session,input={}){
    if(!session||session.userId!==owner)throw new Error('SESSION_OUTCOME_OWNER_MISMATCH');
    if(session.status!=='completed')throw new Error('SESSION_OUTCOME_REQUIRES_COMPLETED_SESSION');
    const existing=await get(session.id);
    if(existing?.syncStatus===SyncStatus.CONFLICT)throw new Error('SESSION_OUTCOME_CONFLICT');
    const value=createSessionOutcome({...existing,...input,sessionId:session.id,userId:owner});
    const stamp=now();
    const entity=existing
      ?{...existing,...value,updatedAt:stamp,syncStatus:existing.syncStatus===SyncStatus.PENDING_CREATE?SyncStatus.PENDING_CREATE:SyncStatus.PENDING_UPDATE}
      :{...createEntityMeta({id:session.id,now:stamp}),...value,id:session.id};
    return queue.enqueue(SESSION_OUTCOME_ENTITY_TYPE,entity,existing&&Number(existing.serverVersion)>0?'update':'create');
  }
  return Object.freeze({get,save,dimensions:DIMENSIONS});
}
